import { ErrorWithCode } from "@cervval.js/common/src/errors/errors";

export interface ErrorWithCodeAndData extends ErrorWithCode {
    data: Record<string, unknown>;
}


export enum NeoplanCustomErrors {
    /**
     * Custom auth errors
     * Should be between 533 & 539 (cf @cervval.js/common-auth & @cervval.js/common/src/errors)
     */
    // #region Custom auth errors
    NO_PERMISSIONS = 533,
    WRONG_SELF_PLANNING_UID = 534,
    // #endregion

    /**
     * Planner engine errors
     * Should be between 600 & 899 (cf @cervval.js/common-auth & @cervval.js/common/src/errors)
     */
    // #region Planner engine errors

    /** Planner engine global errors */
    PLANNER_ENGINE_FAILURE = 610,
    PLANNER_ENGINE_MANUAL_STOP = 611,
    PLANNER_ENGINE_NO_AVAILABLE_DATES = 612,
    /** Session settings errors*/
    PLANNER_ENGINE_SESSION_BEGIN_HOUR_INVALID_FOR_MODULE_BEGIN_HOUR = 613,
    PLANNER_ENGINE_SESSION_BEGIN_HOUR_INVALID_FOR_MODULE_END_HOUR = 614,
    PLANNER_ENGINE_SESSION_DURATION_INVALID_FOR_MODULE = 615,
    PLANNER_ENGINE_SESSION_DURATION_INVALID_FOR_TRAINEE_MAX_RANGE = 616,
    PLANNER_ENGINE_SESSION_DURATION_INVALID_FOR_TRAINEE_MAX_TEACHING = 617,

    PLANNER_ENGINE_SESSION_POSTPONE_BEYOND_LIMIT = 621,
    PLANNER_ENGINE_RULE_POSTPONE_BEYOND_LIMIT = 622,

    // #endregion
}